import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function Confirmation() {
  const [sp] = useSearchParams();
  const order = sp.get("order");
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div className="pt-16 min-h-[80vh] flex items-center" data-testid="confirmation-page">
      <div className="max-w-xl mx-auto px-5 text-center py-20">
        <CheckCircle2 className="text-forest mx-auto mb-6" size={56} />
        <h1 className="font-serif text-4xl text-cream">Order Confirmed</h1>
        <p className="text-cream/70 mt-4 leading-relaxed">
          Thank you for your order. In production this is where Shopify's secure hosted checkout completes payment.
          A confirmation has been recorded.
        </p>
        {order && <p className="text-cream/40 text-sm mt-3">Reference: {order.slice(0, 8)}</p>}
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/shop" className="bg-gold text-espresso px-7 py-3 font-medium hover:bg-amber transition-colors">Continue Shopping</Link>
          <Link to="/" className="border border-cream/30 text-cream px-7 py-3 hover:border-cream transition-colors">Back Home</Link>
        </div>
      </div>
    </div>
  );
}
